/**
 * Horloge de rendu : provoque un nouveau rendu à intervalle régulier.
 *
 * Un compteur du type « en cours depuis 3 min 46 s » se calcule à partir de
 * l'heure courante, mais React ne redessine que lorsqu'un état change : sans
 * cette horloge, la valeur restait figée sur celle du dernier événement reçu —
 * et pendant les longues étapes muettes, comme le scan de sécurité, elle
 * paraissait bloquée.
 */

import { useEffect, useState } from 'react';

/**
 * Retourne l'heure courante, rafraîchie toutes les `intervalMs`.
 *
 * @param active Faux pour arrêter l'horloge — une fois le déploiement terminé,
 *   plus rien ne bouge et il n'y a aucune raison de continuer à redessiner.
 */
export function useTicker(intervalMs = 1000, active = true): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!active) return;
    const timer = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs, active]);

  return now;
}
